import { invariant } from '@seen/core/invariant'
import type { LoaderFunctionArgs } from 'react-router'

export function createLoader(idKey: string) {
  return ({ params }: LoaderFunctionArgs) => {
    const paramValue = params[idKey]
    invariant(paramValue, `Missing required parameter: ${idKey}`)
    return {
      [idKey]: paramValue,
    }
  }
}
